<template>
  <div class='company-select-container'>
    <el-select v-model="selectedCompany"
               value-key="company_id"
               @change="chooseComapny">
      <el-option v-for="(item) in choosedCompanyList"
                 :key="item.company_id"
                 :label="item.company_name"
                 :value="item">
      </el-option>
    </el-select>
    <el-button type="primary"
               @click="showCompanyList">
      选择单位
    </el-button>
    <CompanyListDialog @choose="chooseCompanyCb"
                       :dialogVisible.sync="companyListDialogVisible"></CompanyListDialog>
  </div>
</template>
<script>
import CompanyListDialog from './components/CompanyListDialog'
export default {
  data () {
    return {
      // 已选中的公司列表
      choosedCompanyList: [],
      selectedCompany: {

      },
      // 选择单位弹框是否可见
      companyListDialogVisible: false
    }
  },
  components: {
    CompanyListDialog
  },
  props: {
    choose: {
      type: Function
    }
  },
  methods: {
    chooseComapny () {
      this.$emit('choose', this.selectedCompany)
    },
    showCompanyList () {
      this.companyListDialogVisible = true
    },
    // 选择单位弹框回调事件
    chooseCompanyCb (data) {
      this.selectedCompany = data
      let flag = false
      this.choosedCompanyList.map((item) => {
        if (item.company_id === data.company_id) flag = true
      })
      if (!flag) {
        this.choosedCompanyList.push(data)
      }
      this.$emit('choose', this.selectedCompany)
      // console.log(data, 'call back')
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
.company-select-container {
  width: 320px;
  height: 40px;
  display: flex;
  justify-content: space-between;

}
</style>



// WEBPACK FOOTER //
// src/components/CompanySelect/CompanySelect.vue